import { IndispensableProduct } from '~/models/Product'
import { ProductRepository } from './repository'

export class ProductService {
	static getIndispensables(standardizedCountryName: string): IndispensableProduct[] {
		return ProductRepository.getIndispensables(standardizedCountryName)
	}
}
